import { Component, OnInit } from '@angular/core';

// services
import { DeviceService } from '@open-portal-app/device/services/device.service';

@Component({
  selector: 'device-imei',
  templateUrl: './device-imei.component.html',
  styleUrls: ['./device-imei.component.scss']
})
export class DeviceImeiComponent implements OnInit {

  getImeiClicked: boolean = false;
  oS: string = '';

  constructor(
    private deviceService: DeviceService
  ) { }

  ngOnInit(): void {
    this.oS = this.deviceService.getDeviceDataAttribute('OS');
  }

  getImeiAction() {
    this.getImeiClicked = true;
    window.open('tel:*#06#');
  }
}